import React from 'react';
import { Cpu, Database, Code, Globe, Users } from 'lucide-react';
import { styles } from '../../styles/globalStyles';
import { agentBuilderStyles } from '../../styles/agentBuilderStyles';

const AgentBuilderSection = () => {
  return (
    <section id="build-agents" style={styles.section}>
      <div style={styles.sectionContent}>
        <h2 style={styles.sectionTitle}>
          Build Agents with Visual Interface
        </h2>
        <p style={styles.sectionSubtitle}>
          Drag-and-drop agent builder with MCP protocol integration. 
          Deploy to your infrastructure in minutes, not weeks.
        </p>
        
        <div style={agentBuilderStyles.builderContainer}>
          <div style={agentBuilderStyles.builderSidebar}>
            <h3 style={agentBuilderStyles.builderSidebarTitle}>Components</h3>
            <div style={agentBuilderStyles.componentsList}>
              <div style={agentBuilderStyles.componentItem}>
                <Cpu size={16} />
                <span>LLM Provider</span>
              </div>
              <div style={agentBuilderStyles.componentItem}>
                <Database size={16} />
                <span>Data Source</span>
              </div>
              <div style={agentBuilderStyles.componentItem}>
                <Code size={16} />
                <span>Function Tool</span>
              </div>
              <div style={agentBuilderStyles.componentItem}>
                <Globe size={16} />
                <span>API Connector</span>
              </div>
              <div style={agentBuilderStyles.componentItem}>
                <Users size={16} />
                <span>Human Approval</span>
              </div>
            </div>
          </div>
          
          <div style={agentBuilderStyles.builderCanvas}>
            <div style={agentBuilderStyles.canvasHeader}>
              <span style={agentBuilderStyles.canvasTitle}>Customer Support Agent</span>
              <div style={agentBuilderStyles.canvasActions}>
                <button style={agentBuilderStyles.canvasButton}>Test</button>
                <button style={agentBuilderStyles.canvasButtonPrimary}>Deploy</button>
              </div>
            </div>
            
            <div style={agentBuilderStyles.flowContainer}>
              <div style={agentBuilderStyles.flowNode}>
                <div style={agentBuilderStyles.nodeHeader}>
                  <Cpu size={16} />
                  <span>GPT-4</span>
                </div>
                <div style={agentBuilderStyles.nodeBody}>
                  Model: gpt-4-turbo<br/>
                  Temperature: 0.3<br/>
                  Max Tokens: 1000
                </div>
              </div>
              
              <div style={agentBuilderStyles.flowArrow}>→</div>
              
              <div style={agentBuilderStyles.flowNode}>
                <div style={agentBuilderStyles.nodeHeader}>
                  <Database size={16} />
                  <span>Knowledge Base</span>
                </div>
                <div style={agentBuilderStyles.nodeBody}>
                  Source: Vector DB<br/>
                  Index: customer_docs<br/>
                  Similarity: 0.8
                </div>
              </div>
              
              <div style={agentBuilderStyles.flowArrow}>→</div>
              
              <div style={agentBuilderStyles.flowNode}>
                <div style={agentBuilderStyles.nodeHeader}>
                  <Users size={16} />
                  <span>Escalation</span>
                </div>
                <div style={agentBuilderStyles.nodeBody}>
                  Trigger: confidence &lt; 0.7<br/>
                  Action: notify_human<br/>
                  Slack: #support
                </div>
              </div>
            </div>
            
            <div style={agentBuilderStyles.configPanel}>
              <h4 style={agentBuilderStyles.configTitle}>Agent Configuration</h4>
              <div style={agentBuilderStyles.configGrid}>
                <div style={agentBuilderStyles.configItem}>
                  <label style={agentBuilderStyles.configLabel}>System Prompt</label>
                  <textarea 
                    style={agentBuilderStyles.configTextarea} 
                    value="You are a helpful customer support agent..." 
                    readOnly 
                  />
                </div>
                <div style={agentBuilderStyles.configItem}>
                  <label style={agentBuilderStyles.configLabel}>MCP Server URL</label>
                  <input 
                    style={agentBuilderStyles.configInput} 
                    value="https://api.company.com/mcp" 
                    readOnly 
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgentBuilderSection;